import { Container, Row, Col } from "react-bootstrap";
import { HddStack, Phone, Globe } from "react-bootstrap-icons";
import { services } from "../data/content";

const icons = [HddStack, Phone, Globe];

export const Services = () => {
  return (
    <section className="services" id="servicos">
      <Container>
        <h2>Como posso ajudar</h2>
        <p className="section-subtitle">
          Do backend ao app, posso ajudar a tirar o seu projeto do papel.
        </p>
        <Row className="g-4">
          {services.map((service, index) => {
            const Icon = icons[index];
            return (
              <Col xs={12} md={4} key={service.title}>
                <div className="service-card">
                  <Icon size={32} aria-hidden="true" />
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </Col>
            )
          })}
        </Row>
      </Container>
    </section>
  )
}
